// Hub navigation memory.
//
// We use TWO complementary signals so "back" lands exactly where the
// user came from, every time:
//
//   1. The browser's own history (`window.history`). If the detail page
//      was reached by clicking a row, the previous entry is the list
//      with its filters/scroll already preserved. Browser back is the
//      cheapest, most accurate restoration possible.
//
//   2. A sessionStorage stash of the last hub-list URL. Only consulted
//      when (1) is unsafe — e.g. the user landed on the detail page via
//      a direct link / new tab, so there's no prior in-app entry to go
//      back to. In that case we navigate to the stashed URL (or the
//      caller's fallback) instead of stranding the user.

const KEY = 'bp.taskHub.returnPath'

export const rememberHubReturn = (path) => {
  try {
    if (!path) return
    sessionStorage.setItem(KEY, path)
  } catch {
    /* sessionStorage disabled — silently no-op */
  }
}

export const getHubReturn = (fallback) => {
  try {
    const v = sessionStorage.getItem(KEY)
    return v || fallback
  } catch {
    return fallback
  }
}

// Has the user navigated within this SPA before reaching the current
// page? React Router stamps `location.key === 'default'` only on the
// very first entry of a session — every subsequent in-app navigation
// gets a unique key. So this is a reliable "is there somewhere safe to
// go back to" check.
export const hasInAppHistory = (location) => {
  return !!location && location.key !== 'default'
}

export const clearHubReturn = () => {
  try { sessionStorage.removeItem(KEY) } catch { /* ignore */ }
}
